export const IssuesSystemOptions = [
  "Ark",
  "Fresh Desk",
  "Fresh chat",
  "Printers",
  "Utiligroup",
  "Spark",
  "Website - customer facing",
  "Junifer (all)",
  "Junifer Payments",
  "Junifer Billing",
  "Junifer registrations",
  "Junifer Erroneous Transfers",
]
export const IssuesStatusOptions = [
  "Under investigation",
  "Open",
  "Under review",
  "In progress",
  "Waiting for support",
  "Resolved",
  "Report Pending",
  "Work in progress",
  "Benched",
  "Closed",
]

export const DefaultIssuesStatusOptions = [
  "Under investigation",
  "Open",
  "Under review",
  "In progress",
]

export const DefaultIssuesSystemOptions = [
  "Junifer (all)",
  "Website - customer facing",
  "Spark",
]
